import * as React from 'react';
import './icon.less';
import { ReactComponent as Close } from '../../../../../assets/icons/common/ic_closemenu.svg';
import { ReactComponent as ArrowDown } from '../../../../../assets/icons/common/arrow-down.svg';
import { ReactComponent as ArrowUp } from '../../../../../assets/icons/common/arrow-up.svg';
import { ReactComponent as AppLogo } from '../../../../../assets/images/common/header-logo.svg';
import { ReactComponent as CarouselArrow } from '../../../../../assets/icons/common/ic_setacarrocel.svg';
import { ReactComponent as Warning } from '../../../../../assets/icons/common/ic_aviso.svg';
import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/common/ic_dropcalendario.svg';

export interface IconProps {
	/* set the icon name */
	name: string;
	/* set the width */
	width?: string;
	/* set the height */
	height?: string;
	/* set the fill */
	fill?: string;
	/* set the style */
	style?: {};
	/* set the class */
	className?: string;
	/* set the viewBox */
	viewBox?: string;
}

/*
[COMPONENT USAGE]
	<Icon name="header-logo" />

	[STYLE] you can style the svg like any element in the .less or you can give it a specific className and use it
	svg {
		height: 100px;
		width: 100px;
	path {
		fill: #000;
	}
}
/>
*/

export const Icon: React.FC<IconProps> = (props: IconProps): JSX.Element => {
	switch (props.name) {
		case 'header-logo':
			return <AppLogo {...props} />;
		case 'close':
			return <Close {...props} />;
		case 'arrow-down':
			return <ArrowDown {...props} />;
		case 'arrow-up':
			return <ArrowUp {...props} />;
		case 'carousel-arrow':
			return <CarouselArrow {...props} />;
		case 'warning':
			return <Warning {...props} />;
		case 'calendar-icon':
			return <CalendarIcon {...props} />;
		default:
			return <div />;
	}
};
